import { useMatch } from 'react-router-dom';

import { IconNavItem, Link, Wrapper } from './dropdownNavItemStyle';

interface IProps {
  url?: string;
  onClick?: () => void;
  text?: string;
  matchedPath?: string;
  icon?: JSX.Element;
  hiddenOnSmall?: boolean;
  secondaryNav?: boolean;
}

const DropdownNavItemView = ({
  url,
  onClick,
  text,
  matchedPath,
  icon,
  hiddenOnSmall,
  secondaryNav,
}: IProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isSelected = url ? useMatch({ path: matchedPath || `${url}/*` }) : false;

  const content = icon ? (
    <IconNavItem>
      {icon}
      {text}
    </IconNavItem>
  ) : (
    text
  );

  return (
    <Wrapper
      secondaryNav={secondaryNav}
      hiddenOnSmall={hiddenOnSmall}
      selected={Boolean(isSelected)}
    >
      <Link
        to={url || '#'}
        onClick={onClick}
        selected={Boolean(isSelected)}
        secondaryNav={secondaryNav}
      >
        {content}
      </Link>
    </Wrapper>
  );
};

export default DropdownNavItemView;
